import { render, staticRenderFns } from "./HikVehicleManage.vue?vue&type=template&id=72cf1cb8"
import script from "./HikVehicleManage.vue?vue&type=script&lang=js"
export * from "./HikVehicleManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports